import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  return <section className="w-full bg-[#F5F1E8] py-16 md:py-24 px-4" data-id="element-85">
      <div className="max-w-6xl mx-auto" data-id="element-86">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-87">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-88">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-[#3A3A3A] leading-tight" data-id="element-89">
              No necesitas una casa perfecta. Necesitas una casa que no te
              grite.
            </h1>

            <p className="text-xl md:text-2xl text-[#5A5A5A] leading-relaxed" data-id="element-90">
              El método de 15 minutos para que se note… aunque estés cansada.
            </p>

            <div className="pt-4" data-id="element-91">
              <Button onClick={() => {
              const pricingSection = document.getElementById('pricing');
              pricingSection?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-92">
                Obtener el método ahora
              </Button>
            </div>

            <p className="text-sm text-[#7A7A7A] italic" data-id="element-93">
              Si empiezas y abandonas, no eres floja: te falta un sistema.
            </p>
          </motion.div>

          {/* Hero Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-94">
            <img src="https://cdn.magicpatterns.com/uploads/hxJBV5KXLGA5c83RQNoH71/reset_15.png" alt="Reset de 15 Minutos - Tablet mostrando el método en un ambiente hogareño tranquilo" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-95" />
          </motion.div>
        </div>
      </div>
    </section>;
}